var generateStyle = function generateStyle(componentTheme) {
  return {
    stimulus: {
      paddingTop: componentTheme.stimulusPadding,
      paddingBottom: componentTheme.stimulusPadding
    },
    header: {
      height: '1rem',
      paddingLeft: componentTheme.headerPadding,
      paddingRight: componentTheme.headerPadding,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    leftHeader: {
      display: 'flex',
      overflow: 'hidden'
    },
    stimulusContent: {
      height: '10%0',
      padding: "".concat(componentTheme.stimulusContentPaddingTop, " ").concat(componentTheme.stimulusContentPaddingLeftRight, " ").concat(componentTheme.stimulusContentPaddingBottom)
    }
  };
};
export default generateStyle;